import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  &:not(:last-child) {
    margin-bottom: 2rem;
  }
`;

export const TableTitle = styled.h2`
  font-size: 16px;
  line-height: 1.5715;
  font-weight: 500;
  margin-bottom: 10px;

  &:not(:first-child) {
    margin-top: 35px;
  }
`;
